import { axios } from './config';

export function getSettings() {
  return axios.get('/setting');
};
